// Galleryphotos.js

const createImageArray = (images) => 
  images.map((img, idx) => ({ 
    id: idx + 1, 
    image: img.default 
  }));



// 23. Practical Exam Hall Ticket Distribution Day
const hallTicketDistributionImages = createImageArray([
   require("../../../images/16 Practical Exam Hall Ticket Distrubution 2026/Hallticket1.jpg"),
   require("../../../images/16 Practical Exam Hall Ticket Distrubution 2026/Hallticket2.jpg"),
   require("../../../images/16 Practical Exam Hall Ticket Distrubution 2026/Hallticket3.jpg"),
   require("../../../images/16 Practical Exam Hall Ticket Distrubution 2026/Hallticket4.jpg"),
   require("../../../images/16 Practical Exam Hall Ticket Distrubution 2026/Hallticket5.jpg"),
   require("../../../images/16 Practical Exam Hall Ticket Distrubution 2026/Hallticket6.jpg"),
])

// 15.Vijayavani Expo
    const VijayavaniExpoImages =createImageArray([
     require("../../../images/15 Vijayavani Expo 2026/Vijayavani1.png"),
     require("../../../images/15 Vijayavani Expo 2026/Vijayavani2.png"),
     require("../../../images/15 Vijayavani Expo 2026/Vijayavani3.png"),
     require("../../../images/15 Vijayavani Expo 2026/Vijayavani4.png"),
     require("../../../images/15 Vijayavani Expo 2026/Vijayavani5.png")
    ])

     // 16. Republic Day
    const RepublicDayImages =createImageArray([
     require("../../../images/14 Republic Day 2026/Republic1.png"),
     require("../../../images/14 Republic Day 2026/Republic2.png"),
     require("../../../images/14 Republic Day 2026/Republic3.png"),
     require("../../../images/14 Republic Day 2026/Republic4.png"),
     require("../../../images/14 Republic Day 2026/Republic5.png"),
    ])

    // 22. Martiyers Day
   const martiyersDayImages = createImageArray([
   require("../../../images/13 Martiyers Day 2026/Martiyers1.jpg"),
   require("../../../images/13 Martiyers Day 2026/Martiyers2.jpg"),
   require("../../../images/13 Martiyers Day 2026/Martiyers3.jpg"),
   require("../../../images/13 Martiyers Day 2026/Martiyers4.jpg"),
   require("../../../images/13 Martiyers Day 2026/Martiyers5.jpg"),
   require("../../../images/13 Martiyers Day 2026/Martiyers6.jpg"),
   require("../../../images/13 Martiyers Day 2026/Martiyers7.jpg"),
   require("../../../images/13 Martiyers Day 2026/Martiyers8.jpg"),
   require("../../../images/13 Martiyers Day 2026/Martiyers9.jpg"),
   require("../../../images/13 Martiyers Day 2026/martiyers10.jpg"),
   require("../../../images/13 Martiyers Day 2026/Martiyers11.jpg"),
   require("../../../images/13 Martiyers Day 2026/Martiyers12.jpg")
])

  // 14. Vasanth Panchami
    const VasanthPanchamiImages =createImageArray([
            require("../../../images/12 Vasant Panchami 2026/Panchami1.png"),
            require("../../../images/12 Vasant Panchami 2026/Panchami2.png"),
            require("../../../images/12 Vasant Panchami 2026/Panchami3.png"), 
            require("../../../images/12 Vasant Panchami 2026/Panchami4.png"),
    ])

     // 13. Vivekanada Jayanti
    const VivekanadaImages =createImageArray([
      require("../../../images/11 Vivekanand Jayanti 2026/_DSC0784.JPG"),
      require("../../../images/11 Vivekanand Jayanti 2026/_DSC0790.JPG"),
      require("../../../images/11 Vivekanand Jayanti 2026/_DSC0791.JPG"),
      require("../../../images/11 Vivekanand Jayanti 2026/_DSC0798.JPG"),
      require("../../../images/11 Vivekanand Jayanti 2026/_DSC0810.JPG"),
      require("../../../images/11 Vivekanand Jayanti 2026/_DSC0811.JPG"),
      
    ])

     // 12. Kuvempu Birthday
     const KuvempuImages =createImageArray([
     require("../../../images/10 Kuvempu Birthday 2026/___Kuvempu.jpg"),
     require("../../../images/10 Kuvempu Birthday 2026/__Kuvempu.jpg"),
     require("../../../images/10 Kuvempu Birthday 2026/_Kuvempu.jpg"),
     ]);

    // 21. Children's Day
     const childrensDayImages =createImageArray( [
     require("../../../images/09 Children’s Day 2026/_DSC0734.JPG"),
     require("../../../images/09 Children’s Day 2026/_DSC0736.JPG"),
     require("../../../images/09 Children’s Day 2026/_DSC0747.JPG"),
     require("../../../images/09 Children’s Day 2026/_DSC0751.JPG"),
     require("../../../images/09 Children’s Day 2026/_DSC0757.JPG"),
     require("../../../images/09 Children’s Day 2026/_DSC0771.JPG")
    ]);

     // 20. Karnataka Rajyotsava
  const RajotsavaImages = createImageArray([
  require("../../../images/08 Karnataka Rajyotsava 2026/Karnataka1.png"),
  require("../../../images/08 Karnataka Rajyotsava 2026/Karnataka2.png"),
  require("../../../images/08 Karnataka Rajyotsava 2026/Karnataka3.png"),
  require("../../../images/08 Karnataka Rajyotsava 2026/Karnataka4.png"),
  require("../../../images/08 Karnataka Rajyotsava 2026/Karnataka5.png"),
  require("../../../images/08 Karnataka Rajyotsava 2026/Karnataka6.png"),
  require("../../../images/08 Karnataka Rajyotsava 2026/Karnataka7.png"),
  require("../../../images/08 Karnataka Rajyotsava 2026/Karnataka8.png")
 ]);

   // 11. Gandhi & Shastree Jayanti
  const GandhiShastreeImages =createImageArray( [
  require("../../../images/07 Gandhi & Shastri Jayanti 2026/_DSC0242.JPG"),
  require("../../../images/07 Gandhi & Shastri Jayanti 2026/_DSC0243.JPG"),
  require("../../../images/07 Gandhi & Shastri Jayanti 2026/_DSC0271.JPG"),
  require("../../../images/07 Gandhi & Shastri Jayanti 2026/_DSC0273.JPG"),
 ]);

  // 19. Hindi Diwas
  const HindiDiwasImages = createImageArray( [
  require("../../../images/06 Hindi Diwas 2026/HindiDiwas1.JPG"),
  require("../../../images/06 Hindi Diwas 2026/HindiDiwas2.JPG"),
  require("../../../images/06 Hindi Diwas 2026/HindiDiwas3.JPG"),
  require("../../../images/06 Hindi Diwas 2026/HindiDiwas4.JPG"),
  require("../../../images/06 Hindi Diwas 2026/HindiDiwas5.JPG"),
  require("../../../images/06 Hindi Diwas 2026/HindiDiwas6.JPG")
 ]);

  // 18. Teachers Day
  const teacherdayImages = createImageArray( [
  require("../../../images/05 Teachers’ Day 2026/Teachersday1.JPG"),
  require("../../../images/05 Teachers’ Day 2026/Teachersday2.JPG"),
  require("../../../images/05 Teachers’ Day 2026/Teachersday3.JPG"),
  require("../../../images/05 Teachers’ Day 2026/Teachersday4.JPG"),
  require("../../../images/05 Teachers’ Day 2026/Teachersday5.JPG"),
  require("../../../images/05 Teachers’ Day 2026/Teachersday6.JPG"),
]);
 
   // 10. Ganesh Chaturthi
  const ganeshImages =createImageArray( [
  require("../../../images/04 Ganesh Chaturthi 2026/GaneshchaturtiNew1.JPG"),
  require("../../../images/04 Ganesh Chaturthi 2026/GaneshchaturtiNew2.JPG"),
  require("../../../images/04 Ganesh Chaturthi 2026/GaneshchaturtiNew3.JPG"),
  require("../../../images/04 Ganesh Chaturthi 2026/Ganeshchaturti4.JPG"),
  require("../../../images/04 Ganesh Chaturthi 2026/Ganeshchaturti5.JPG"),
  require("../../../images/04 Ganesh Chaturthi 2026/Ganeshchaturti6.JPG"),
 ]);
 
  // 7. Independence Day
  const independenceDayImages =createImageArray( [
  require("../../../images/03 Independence Day 2026/IndependenceNew1.JPG"),
  require("../../../images/03 Independence Day 2026/IndependenceNew2.JPG"),
  require("../../../images/03 Independence Day 2026/IndependenceNew6.JPG"),
  require("../../../images/03 Independence Day 2026/IndependenceNew4.JPG"),
  require("../../../images/03 Independence Day 2026/IndependenceNew5.JPG"),
  require("../../../images/03 Independence Day 2026/IndependenceNew3.JPG"),
  require("../../../images/03 Independence Day 2026/IndependenceNew7.JPG")
 ]);
 
 // 9. Raksha Bandan
  const rakshaImages =createImageArray( [
  require("../../../images/02 Raksha Bandhan 2026/RakshabandanNew1.png"),
  require("../../../images/02 Raksha Bandhan 2026/RakshabandanNew2.png"),
  require("../../../images/02 Raksha Bandhan 2026/RakshabandanNew3.png"),
  require("../../../images/02 Raksha Bandhan 2026/RakshabandanNew4.png"),
  require("../../../images/02 Raksha Bandhan 2026/RakshabandanNew5.png"),
  require("../../../images/02 Raksha Bandhan 2026/RakshabandanNew6.png")
]);
 
  // 6. Sanganabasava Swamiji Birthday
  const birthdayImages =createImageArray( [
  require("../../../images/01 Swamiji Birthday Celebration 2026/SwamijiNew1.JPG"),
  require("../../../images/01 Swamiji Birthday Celebration 2026/SwamijiNew2.JPG"),
  require("../../../images/01 Swamiji Birthday Celebration 2026/SwamijiNew3.JPG"),
  require("../../../images/01 Swamiji Birthday Celebration 2026/SwamijiNew4.JPG"),
  require("../../../images/01 Swamiji Birthday Celebration 2026/SwamijiNew5.JPG"),
  require("../../../images/01 Swamiji Birthday Celebration 2026/SwamijiNew6.JPG"),
  require("../../../images/01 Swamiji Birthday Celebration 2026/SwamijiNew7.JPG"),
 ]);
 
 //25. principal group photo 2025

  const PrinciGroupImages = createImageArray([
  require("../../../images/principal group photos 2025-04-04/staff1.jpeg"),
  require("../../../images/principal group photos 2025-04-04/staff2.jpeg"),
  require("../../../images/principal group photos 2025-04-04/staff3.jpeg"),
  require("../../../images/principal group photos 2025-04-04/staff4.jpeg"),
  require("../../../images/principal group photos 2025-04-04/staff5.jpeg"),
 ])
 
 // 24. Annual Day
 const AnnualDayImages = createImageArray( [
  require("../../../images/photo24/annualday24/a1.JPG"),
  require("../../../images/photo24/annualday24/a2.JPG"),
  require("../../../images/photo24/annualday24/a3.JPG"),
  require("../../../images/photo24/annualday24/a4.JPG"),
  require("../../../images/photo24/annualday24/a5.JPG"),
  require("../../../images/photo24/annualday24/a6.JPG"),
  require("../../../images/photo24/annualday24/a7.JPG"),
  require("../../../images/photo24/annualday24/a8.JPG")
 ]);
 
   // 17. Dahi Handi Competition
 const dahiHandiImages = createImageArray( [
  require("../../../images/10.dahi handi competition/_DSC0798.JPG"),
  require("../../../images/10.dahi handi competition/_DSC0827.JPG"),
  require("../../../images/10.dahi handi competition/_DSC0830.JPG"),
  require("../../../images/10.dahi handi competition/_DSC0849.JPG"),
  require("../../../images/10.dahi handi competition/_DSC0885.JPG"),
  require("../../../images/10.dahi handi competition/_DSC0890.JPG"),
  require("../../../images/10.dahi handi competition/_DSC0905.JPG"),
  require("../../../images/10.dahi handi competition/_DSC0931.JPG")
 ]);
 
  // 8. Cross Country Race
 const raceImages =createImageArray( [
  require("../../../images/8.cross country race/_DSC0259.JPG"),
  require("../../../images/8.cross country race/_DSC0264.JPG"),
  require("../../../images/8.cross country race/_DSC0288.JPG"),
  require("../../../images/8.cross country race/_DSC0292.JPG"),
  require("../../../images/8.cross country race/_DSC0331.JPG"),
  require("../../../images/8.cross country race/_DSC0412.JPG"),
  require("../../../images/8.cross country race/_DSC0433.JPG"),
  require("../../../images/8.cross country race/_DSC0442.JPG"),
  require("../../../images/8.cross country race/_DSC0447.JPG"),
  require("../../../images/8.cross country race/_DSC0629.JPG")
 ]);
 
   // 5. ABVP Program
  const abvpImages =createImageArray( [
  require("../../../images/5.ABVP PROGRAM/_DSC0362.JPG"),
  require("../../../images/5.ABVP PROGRAM/_DSC0364.JPG"),
  require("../../../images/5.ABVP PROGRAM/_DSC0368.JPG"),
  require("../../../images/5.ABVP PROGRAM/_DSC0370.JPG"),
  require("../../../images/5.ABVP PROGRAM/_DSC0371.JPG"),
  require("../../../images/5.ABVP PROGRAM/_DSC0372.JPG"),
  require("../../../images/5.ABVP PROGRAM/_DSC0388.JPG"),
  require("../../../images/5.ABVP PROGRAM/_DSC0391.JPG"),
  require("../../../images/5.ABVP PROGRAM/_DSC0394.JPG"),
  require("../../../images/5.ABVP PROGRAM/_DSC0405.JPG")
 ]);
 
  // 4. Freshers Day
  const fresherImages =createImageArray( [
  require("../../../images/4.FRESHERS day/_DSC0320.JPG"),
  require("../../../images/4.FRESHERS day/_DSC0324.JPG"),
  require("../../../images/4.FRESHERS day/_DSC0331.JPG"),
  require("../../../images/4.FRESHERS day/DSC_0526.JPG"),
  require("../../../images/4.FRESHERS day/DSC_0606.JPG"),
  require("../../../images/4.FRESHERS day/DSC_0639.JPG"),
  require("../../../images/4.FRESHERS day/DSC_0707.JPG"),
  require("../../../images/4.FRESHERS day/DSC_0722.JPG"),
  require("../../../images/4.FRESHERS day/DSC_0731.JPG"),
  require("../../../images/4.FRESHERS day/DSC_0820.JPG")
 ]);
 
 // 1. World Environment Day
 const  worldImages =createImageArray( [
  require("../../../images/1.WORLD ENVIRONMENT DAY/_DSC0530.JPG"),
  require("../../../images/1.WORLD ENVIRONMENT DAY/_DSC0532.JPG"),
  require("../../../images/1.WORLD ENVIRONMENT DAY/_DSC0535.JPG"),
  require("../../../images/1.WORLD ENVIRONMENT DAY/_DSC0538.JPG"),
  require("../../../images/1.WORLD ENVIRONMENT DAY/_DSC0548.JPG"),
  require("../../../images/1.WORLD ENVIRONMENT DAY/_DSC0554.JPG"),
  require("../../../images/1.WORLD ENVIRONMENT DAY/_DSC0559.JPG"),
  require("../../../images/1.WORLD ENVIRONMENT DAY/_DSC0564.JPG"),
  require("../../../images/1.WORLD ENVIRONMENT DAY/_DSC0567.JPG"),
  require("../../../images/1.WORLD ENVIRONMENT DAY/_DSC0574.JPG"),
 ]);

 // 2. Saraswati Pooja & Orientation Program
  const saraImages =createImageArray( [
  require("../../../images/2.saraswati pooja & Orientation program/DSC_0759.JPG"),
  require("../../../images/2.saraswati pooja & Orientation program/DSC_0793.JPG"),
  require("../../../images/2.saraswati pooja & Orientation program/DSC_0803.JPG"),
  require("../../../images/2.saraswati pooja & Orientation program/DSC_0824.JPG"),
  require("../../../images/2.saraswati pooja & Orientation program/DSC_0837.JPG"),
  require("../../../images/2.saraswati pooja & Orientation program/DSC_0854.JPG"),
  require("../../../images/2.saraswati pooja & Orientation program/DSC_0901.JPG"),
  require("../../../images/2.saraswati pooja & Orientation program/DSC_0919.JPG"),
  require("../../../images/2.saraswati pooja & Orientation program/DSC_0921.JPG"),
  require("../../../images/2.saraswati pooja & Orientation program/DSC_0932.JPG")
 ]);

 // 3. Yoga Day
  const yogaImages =createImageArray([
  require("../../../images/3.YOGA DAY/_DSC0132.JPG"),
  require("../../../images/3.YOGA DAY/_DSC0133.JPG"),
  require("../../../images/3.YOGA DAY/_DSC0146.JPG"),
  require("../../../images/3.YOGA DAY/_DSC0152.JPG"),
  require("../../../images/3.YOGA DAY/_DSC0159.JPG"),
  require("../../../images/3.YOGA DAY/_DSC0169.JPG"),
  require("../../../images/3.YOGA DAY/_DSC0181.JPG"),
  require("../../../images/3.YOGA DAY/_DSC0215.JPG"),
  require("../../../images/3.YOGA DAY/_DSC0225.JPG"),
  require("../../../images/3.YOGA DAY/_DSC0232.JPG")
 ]);

 // ==================== Exports ==================== //
export { 
  worldImages,
  saraImages,
  yogaImages,
  fresherImages,
  abvpImages,
  birthdayImages,
  independenceDayImages,
  raceImages,
  ganeshImages,
  GandhiShastreeImages,
  KuvempuImages,
  VivekanadaImages,
  VasanthPanchamiImages,
  VijayavaniExpoImages,
  RepublicDayImages,
  rakshaImages,
  dahiHandiImages,
  teacherdayImages,
  HindiDiwasImages,
  RajotsavaImages,
  childrensDayImages,
  martiyersDayImages,
  hallTicketDistributionImages,
  AnnualDayImages,
  PrinciGroupImages
};